import {
  Phone,
  Mail,
  MapPin,
  Clock,
  Send,
} from "lucide-react";

function Contact() {
  return (
    <section
      id="contact"
      className="py-24 bg-gradient-to-br from-blue-50 via-white to-blue-100"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">

        {/* Heading */}

        <div className="text-center mb-16">

          <span className="bg-blue-100 text-blue-700 px-5 py-2 rounded-full font-semibold">
            Contact Us
          </span>

          <h2 className="text-4xl lg:text-5xl font-bold mt-6">
            Let's Build Your
            <span className="text-blue-700"> Digital Future</span>
          </h2>

          <p className="mt-5 text-gray-600 max-w-2xl mx-auto">
            Have questions about our courses? We're here to help you choose the right learning path.
          </p>

        </div>

        <div className="grid lg:grid-cols-2 gap-12">

          {/* Left Side */}

          <div className="space-y-6">

            <div className="flex items-start gap-5 bg-white p-6 rounded-2xl shadow-md">

              <div className="bg-blue-100 p-4 rounded-xl text-blue-700">
                <Phone size={28} />
              </div>

              <div>
                <h3 className="text-xl font-bold">Phone</h3>
                <p className="text-gray-600 mt-2">
                  +91 8817289144
                </p>
              </div>

            </div>

            <div className="flex items-start gap-5 bg-white p-6 rounded-2xl shadow-md">

              <div className="bg-blue-100 p-4 rounded-xl text-blue-700">
                <Mail size={28} />
              </div>

              <div>
                <h3 className="text-xl font-bold">Email</h3>
                <p className="text-gray-600 mt-2">
                  digitalwithpriyanshi@gmail.com
                </p>
              </div>

            </div>

            <div className="flex items-start gap-5 bg-white p-6 rounded-2xl shadow-md">

              <div className="bg-blue-100 p-4 rounded-xl text-blue-700">
                <MapPin size={28} />
              </div>

              <div>
                <h3 className="text-xl font-bold">Address</h3>
                <p className="text-gray-600 mt-2">
                  Alkapuri Ambe Chowk, B/277, Alkapuri, Ratlam,(M.P.) 457001
                </p>
              </div>

            </div>

            <div className="flex items-start gap-5 bg-white p-6 rounded-2xl shadow-md">

              <div className="bg-blue-100 p-4 rounded-xl text-blue-700">
                <Clock size={28} />
              </div>

              <div>
                <h3 className="text-xl font-bold">Working Hours</h3>
                <p className="text-gray-600 mt-2">
                  Monday - Saturday
                </p>

                <p className="text-gray-600">
                  10:00 AM - 7:00 PM
                </p>
              </div>

            </div>

          </div>

          {/* Right Side */}

          <div className="bg-white rounded-3xl shadow-xl p-8">

            <h3 className="text-3xl font-bold mb-8">
              Send us a Message
            </h3>

            <form className="space-y-6">

              <input
                type="text"
                placeholder="Your Name"
                className="w-full border border-gray-300 rounded-xl px-5 py-4 focus:outline-none focus:ring-2 focus:ring-blue-600"
              />

              <input
                type="email"
                placeholder="Email Address"
                className="w-full border border-gray-300 rounded-xl px-5 py-4 focus:outline-none focus:ring-2 focus:ring-blue-600"
              />

              <input
                type="tel"
                placeholder="Phone Number"
                className="w-full border border-gray-300 rounded-xl px-5 py-4 focus:outline-none focus:ring-2 focus:ring-blue-600"
              />

              <textarea
                rows="5"
                placeholder="Write your message..."
                className="w-full border border-gray-300 rounded-xl px-5 py-4 focus:outline-none focus:ring-2 focus:ring-blue-600"
              ></textarea>

              <button
                type="submit"
                className="w-full bg-blue-700 hover:bg-blue-800 text-white py-4 rounded-xl font-semibold flex justify-center items-center gap-3 transition"
              >
                <Send size={20} />
                Send Message
              </button>

            </form>

          </div>

        </div>

      </div>
    </section>
  );
}

export default Contact;